<template>
  <div>
    <vx-card>
      <ListIntegracoesSGAdePara></ListIntegracoesSGAdePara>
    </vx-card>
  </div>
</template>

<script>
import ListIntegracoesSGAdePara from "./../../lists/ListIntegracoesSGAdePara";

export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    ListIntegracoesSGAdePara
  }
};
</script>
